import { render, staticRenderFns } from "./workOrderTb.vue?vue&type=template&id=0f51adb2"
import script from "./workOrderTb.vue?vue&type=script&lang=js"
export * from "./workOrderTb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports